<template>
  <div :class="$style.container">
    <img
      :src="photoUrl"
      :class="$style.userImage"
      :style="{borderColor: groupColor}"
      :title="user.name"
      v-tippy />
    <a
      :href="playbackUrl"
      target="_blank"
      :class="$style.activity">{{activityTitle}}</a>
    <p :class="$style.type">{{typeLabel}}</p>
    <p :class="$style.date">{{ formattedDate }}</p>
    <div ref="message" :class="$style.message">{{ message }}</div>
  </div>
</template>

<script>
import moment from 'moment'
import { linkifyElement } from 'vue-components/utils/linkify'
import { jiminnyHost } from '@/helpers/region'
import defaultAvatar from '@/assets/img/default-avatar.svg'

export default {
  props: [
    'user',
    'date',
    'message',
    'type',
    'activity'
  ],
  computed: {
    photoUrl () {
      return this.user.photoUrl
        ? this.user.photoUrl
        : defaultAvatar
    },
    groupColor () {
      return this.user.group && this.user.group.color
    },
    playbackUrl () {
      return `${jiminnyHost()}/playback/${this.activity.id}?apFrom=0`
    },
    formattedDate () {
      return moment(this.date).fromNow()
    },
    activityTitle () {
      return this.activity.title
    },
    typeLabel () {
      return this.type === 1
        ? 'What went well?'
        : 'Game Changer'
    }
  },
  mounted () {
    linkifyElement(this.$refs.message)
  }
}
</script>

<style module lang="less" src="./FocusComment.less"></style>



// WEBPACK FOOTER //
// FocusComment.vue?5bff3ffc